<template>
  <div class="text--primary">
    <v-row class="text--primary">
      <v-col cols="12" sm="8" class="text--primary title font-weight-bold">
        <px-span-tooltip
          v-if="fornecedor.fornecedor.codigoInterno"
          bottom
          text-class="subtitle-1 font-weight-bold"
          :text="`(${fornecedor.fornecedor.codigoInterno})`"
          tooltip="Código interno do fornecedor"/>
          {{ fornecedor.fornecedor.pessoa.nome }} (
            <px-fornecedor-documento :fornecedor="fornecedor.fornecedor"/>
            )
      </v-col>
      <v-col cols="12" sm="4" class="text-right">
        <v-tooltip top v-if="!this.disableActions && this.hasRoleComprador">
          <template v-slot:activator="{ on }">
            <v-btn color="primary"
                   class="normal-btn-text elevation-0 rounded-tag-small"
                   v-on="on"
                   @click.stop="finalizar(fornecedor)"
                   title="Solicitar confirmação da compra para o fornecedor">
              Solicitar confirmação
            </v-btn>
          </template>
          <span>Enviar o pedido para o fornecedor</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="text--primary heading">
      <v-col cols="12" class="text--primary heading subtitle-1">
        <v-icon>mdi-domain</v-icon>
        <px-span-tooltip top :text="fornecedor.comprador.pessoa.nome"
                         tooltip="Empresa compradora"/>
        ({{ fornecedor.comprador.pessoa.cnpj | cnpj }})
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
      <px-listagem-carrinho-respostas :fornecedor="fornecedor"
                                      :disable-actions="disableActions"
                                      :remover-carrinho="removerCarrinho"
                                      :remover-produto="removerProduto"/>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ListagemCarrinhoRespostas from './ListagemCarrinhoRespostas.vue';

export default {
  name: 'ListagemCarrinhoFornecedores',
  components: { pxListagemCarrinhoRespostas: ListagemCarrinhoRespostas },
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
    disableActions: {
      default: false,
    },
    finalizar: {
      type: Function,
      required: true,
    },
    removerCarrinho: {
      type: Function,
      required: true,
    },
    removerProduto: {
      type: Function,
      required: true,
    },
    codigoInterno: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
  },
};
</script>
